<div class="overlay" *ngIf="isLoading | async">
    <div class="spinner">
        <div class="spinner-part spinner-part1"></div>
        <div class="spinner-part spinner-part2"></div>
        <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
    </div>
</div>
<div class="container-fluid pl-0">
    <div class="container-inner">
        <ng-container *ngIf="!isCreate && !isUserVerification">
            <div class="header-container">
                <h2>Users</h2>
                <div class="search-and-filter-container">
                    <div class="search-container">
                        <input type="text" [formControl]="searchInput" placeholder="Search..." (input)="applyFilter()"
                            class="form-control" />
                        <span class="clear-icon" *ngIf="searchInput.value" (click)="clearSearch()">&times;</span>
                    </div>
                    <div class="status-filter-container">
                        <select [formControl]="outletFilter" class="form-select status-select">
                            <option value="All">All</option>
                            <option value="1">Active Outlet</option>
                            <option value="2">Inactive Outlet</option>
                        </select>
                    </div>
                    <div class="status-filter-container">
                        <select [formControl]="statusFilter" class="form-select status-select">
                            <option value="All">All</option>
                            <option value="1">New</option>
                            <option value="2">Terminated</option>
                            <option value="4">Segment Change</option>
                            <option value="3">Dealer Change</option>
                            <option value="5">Contact No. Change</option>
                        </select>
                    </div>
                </div>
                <div class="button-container">
                    <div class="dropdown" style="z-index: 999;">
                        <button class="export-button btn btn-secondary dropdown-toggle" type="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            Export
                        </button>
                        <ul class="dropdown-menu">
                            <li *ngFor="let roleData of exportOptions" (click)="exportData(roleData.id)"><a
                                    class="dropdown-item" role="button">{{roleData.name}}</a></li>
                        </ul>
                    </div>
                    <button mat-raised-button class="add-button mr-1" routerLink="/suzuki/upload-users"><img
                            class="upload-img" src="/assets/images/upload.png" alt=""> Import</button>
                    <button mat-raised-button class="add-button" (click)="add()">Add User</button>
                </div>
            </div>
            <div class="leads-table mb-3">
                <table mat-table [dataSource]="dataSource" matSort class="mat-table">
                    <ng-container matColumnDef="SNo">
                        <th mat-header-cell *matHeaderCellDef> S.No </th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            {{ (paginatorRef.pageIndex * paginatorRef.pageSize)
                            + (i + 1) }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="first_name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
                        <td mat-cell *matCellDef="let element">{{element.first_name ?
                            element.first_name : 'NA'}}</td>
                    </ng-container>
                    <ng-container matColumnDef="role_id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Role</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.role.role }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                        <td mat-cell *matCellDef="let element">{{element.email ?
                            element.email : 'NA'}}</td>
                    </ng-container>
                    <ng-container matColumnDef="username">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>User ID</th>
                        <td mat-cell *matCellDef="let element">{{element.username ?
                            element.username : 'NA'}}</td>
                    </ng-container>
                    <ng-container matColumnDef="mobile">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile</th>
                        <td mat-cell *matCellDef="let element">{{element.mobile
                            ? element.mobile : 'NA'}}</td>
                    </ng-container>
                    <ng-container matColumnDef="outlets">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Outlets</th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="element.role_id != 10">
                                {{element?.outlet?.outlet_name ? element.outlet.outlet_name + ' (' +
                                element.outlet.outlet_code + ')' : 'NA'}}
                            </ng-container>
                            <ng-container *ngIf="element.role_id == 10">
                                {{ element?.parent_dealer?.dealer_name && element?.parent_dealer?.dealer_code
                                ? element.parent_dealer.dealer_name + ' (' + element.parent_dealer.dealer_code + ')'
                                : 'NA' }}
                            </ng-container>
                        </td>
                    </ng-container>
                    <!-- Action Column -->
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;">Status</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="status-button-wrapper">
                                <span [ngClass]="element?.status ? 'status-active' : 'status-inactive'">
                                    {{ element?.status ? 'Active' : 'InActive' }}
                                </span>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="block">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;">UnBlock</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="status-button-wrapper"
                                style="display: flex; flex-direction: column; align-items: center;">
                                <button class="custom-unblock-button" [disabled]="element?.reset_flag != 3" mat-button
                                    style="color:white;font-size:12px" (click)="toggleBlock(element)">
                                    {{ element?.reset_flag ? 'Unblock' : 'Unblock' }}
                                </button>
                            </div>
                        </td>
                    </ng-container>



                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;">Action</th>

                        <td mat-cell *matCellDef="let element" style="text-align: center;">
                            <div class="icon-row">
                                <div class="status-button-wrapper"
                                    style="display: flex; flex-direction: column; align-items: center;">
                                    <button class="custom-unblock-button"
                                        [disabled]="!['2', '3', '4'].includes(element?.reset_flag)" mat-button
                                        style="color:white;font-size:12px !important;" (click)="toggleBlock(element)">
                                        {{ element?.reset_flag ? 'Unblock' : 'Unblock' }}
                                    </button>
                                </div>
                                <img src="/assets/images/key.png" class="edit-pen mr-2" title="Password"
                                    (click)="openSetPassword(element)">
                                <img [src]="bucketurl + '/images/pen.png'" class="edit-pen" title="Edit"
                                    (click)="openEditPopup(element)">
                                <img [src]="bucketurl + '/images/verified-profile.png'" class="edit-view"
                                    style="width: 30px; margin-left: 6px;" title="View" (click)="viewUserData(element)">
                            </div>
                        </td>

                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
            <mat-paginator #paginatorRef [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>

        </ng-container>
        <ng-container *ngIf="isCreate && !isUserVerification">
            <div class="header-container">
                <h2>Users</h2>
                <div class="button-container">
                    <button mat-raised-button class="add-button" (click)="back()">Back to List</button>
                </div>
            </div>
            <form [formGroup]="userForm" autocomplete="off">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                        <div class="themeinput">
                            <label>First Name</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                            <!-- <mat-form-field appearance="outline"> -->
                            <input type="text" class="form-control" formControlName="first_name" maxlength="30"
                                [attr.value]="userForm.get('first_name')?.value"
                                [ngClass]="{ 'is-invalid': submitted && f['first_name'].errors }" />
                            <div class="invalid-feedback" *ngIf="submitted && f['first_name'].errors">
                                <div *ngIf="f['first_name'].errors['required']">First
                                    Name is required</div>
                            </div>
                            <!-- </mat-form-field> -->
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                        <div class="themeinput">
                            <label>Last Name</label>
                            <!-- <mat-form-field appearance="outline"> -->
                            <input type="text" class="form-control" formControlName="last_name" maxlength="30"
                                [attr.value]="userForm.get('last_name')?.value"
                                [ngClass]="{ 'is-invalid': submitted && f['last_name'].errors }" />
                            <div class="invalid-feedback" *ngIf="submitted && f['last_name'].errors">
                                <div *ngIf="f['last_name'].errors['required']">Last
                                    Name is required</div>
                            </div>
                            <!-- </mat-form-field> -->
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                        <div class="themeinput">
                            <label>Email</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                            <!-- <mat-form-field appearance="outline"> -->
                            <input class="form-control" type="email" formControlName="email" maxlength="50"
                                [ngClass]="{ 'is-invalid': submitted && f['email'].errors }"
                                [attr.value]="userForm.get('email')?.value" (ngModelChange)="onEmailChange($event)" />
                            <div class="invalid-feedback" *ngIf="submitted && f['email'].errors">
                                <div *ngIf="f['email'].errors['required']">Email
                                    is required</div>
                                <div *ngIf="f['email'].errors['email']">Invalid
                                    email format</div>
                            </div>
                            <!-- </mat-form-field> -->
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                        <div class="themeinput">
                            <label>User ID</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                            <!-- <mat-form-field appearance="outline"> -->
                            <input class="form-control" type="username" formControlName="username" maxlength="50"
                                [ngClass]="{ 'is-invalid': submitted && f['username'].errors }"
                                [attr.value]="userForm.get('username')?.value" />
                            <div class="invalid-feedback" *ngIf="submitted && f['username'].errors">
                                <div *ngIf="f['username'].errors['required']">User ID
                                    is required</div>
                                <div *ngIf="f['username'].errors['username']">Invalid
                                    userid format</div>
                            </div>
                            <!-- </mat-form-field> -->
                        </div>
                    </div>

                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                        <div class="themeinput">
                            <label>Mobile</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                            <!-- <mat-form-field appearance="outline"> -->
                            <input class="form-control" type="text" formControlName="mobile" maxlength="10"
                                (keypress)="keyPress($event)" pattern="[0-9]*"
                                [attr.value]="userForm.get('mobile')?.value"
                                [ngClass]="{ 'is-invalid': submitted && f['mobile'].errors }" />
                            <div class="invalid-feedback" *ngIf="submitted && f['mobile'].errors">
                                <div *ngIf="f['mobile'].errors['required']">Mobile
                                    number is required</div>
                                <div *ngIf="f['mobile'].errors['pattern']">Please
                                    enter valid numbers only</div>
                                <div *ngIf="f['mobile'].errors['maxlength']">Mobile
                                    number must be exactly 10 digits</div>
                            </div>
                            <!-- </mat-form-field> -->
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                        <div class="themeinput">
                            <label>Alternate Mobile</label>
                            <!-- <mat-form-field appearance="outline"> -->
                            <input type="text" class="form-control" formControlName="alternate_mobile" maxlength="10"
                                (keypress)="keyPress($event)" pattern="[0-9]*" autocomplete="new-password"
                                [attr.value]="userForm.get('alternate_mobile')?.value"
                                [ngClass]="{ 'is-invalid': submitted && f['alternate_mobile'].errors }" />
                            <div class="invalid-feedback" *ngIf="submitted && f['alternate_mobile'].errors">
                                <div *ngIf="f['alternate_mobile'].errors['pattern']">Please
                                    enter valid numbers only</div>
                                <div *ngIf="f['alternate_mobile'].errors['maxlength']">Alternate
                                    mobile number must be exactly 10
                                    digits</div>
                            </div>
                            <!-- </mat-form-field> -->
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                        <div class="themeinput">
                            <label>Password</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                            <!-- <mat-form-field appearance="outline"> -->
                            <div class="input-group">

                                <input class="form-control m-0" [type]="showPassword ? 'text' : 'password'"
                                    formControlName="password" minlength="8" autocomplete="new-password"
                                    [attr.value]="userForm.get('password')?.value"
                                    [ngClass]="{ 'is-invalid': submitted && f['password'].errors }" />
                                <div class="input-group-append">
                                    <span class="input-group-text pwd-eye" (click)="togglePasswordVisibility()">
                                        <i class="fa"
                                            [ngClass]="{'fa-eye-slash': !showPassword, 'fa-eye': showPassword}"></i>
                                    </span>
                                </div>
                                <div class="invalid-feedback" *ngIf="submitted && f['password'].errors">
                                    <div *ngIf="f['password'].errors['required']">Password
                                        is required</div>
                                    <div *ngIf="f['password'].errors['pattern']">
                                        Password must be at least 8 characters long, include a number, a special
                                        character and a capital letter.
                                    </div>
                                </div>
                            </div>
                            <!-- </mat-form-field> -->
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                        <div class="themeinput">
                            <label>Role</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                            <!-- <mat-form-field appearance="outline"> -->
                            <select formControlName="role_id" class="form-select"
                                [attr.value]="userForm.get('role_id')?.value"
                                [ngClass]="{ 'is-invalid': submitted && f['role_id'].errors }">
                                <option value="" selected disabled>--Select
                                    Role--</option>
                                <option *ngFor="let roleData of roleValue" [value]="roleData.id">{{ roleData.role
                                    }}</option>
                            </select>
                            <div class="invalid-feedback" *ngIf="submitted && f['role_id'].errors">
                                <div *ngIf="f['role_id'].errors['required']">Role
                                    is required</div>
                            </div>
                            <!-- </mat-form-field> -->
                        </div>
                    </div>
                    <!-- Outlet Dropdown -->
                    <div *ngIf="isOutletRole" class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                        <label>Outlet</label>
                        <!-- <span style="color: red; font-size: 15px;">&nbsp;*</span>
                        <select formControlName="outlet_id" class="form-select outlet-select"
                            [attr.value]="userForm.get('outlet_id')?.value"
                            [ngClass]="{ 'is-invalid': submitted && f['outlet_id'].errors }"
                            (change)="onOutletChange($event)">
                            <option value="" disabled selected>--Select
                                Outlet--</option>
                            <option *ngFor="let outletData of out_letValue" [value]="outletData.id"
                                [disabled]="outletData.disable">{{
                                outletData.outlet_name }} - {{outletData.outlet_code}}</option>
                        </select> -->
                        <ng-multiselect-dropdown [placeholder]="'Select Outlet'" formControlName="outlet_id"
                            class="form-control" [settings]="outletSetting" [data]="out_letValue"
                            [ngClass]="{ 'is-invalid': submitted && f['outlet_id'].errors }"
                            (onSelect)="onOutletChange($event)" (onDeSelect)="onOutletChange($event)">
                        </ng-multiselect-dropdown>
                        <div class="invalid-feedback" *ngIf="submitted && f['outlet_id'].errors">
                            <div *ngIf="f['outlet_id'].errors['required']">Outlet
                                is required</div>
                        </div>
                        <!-- <label>Outlet</label>
                        <span style="color: red; font-size: 15px;">&nbsp;*</span>
                        <ng-select 
                            formControlName="outlet_id"
                            [items]="out_letValue"
                            bindLabel="outlet_name"
                            bindValue="id"
                            [placeholder]="' '"
                            [clearable]="!!userForm.get('outlet_id')?.value"
                            [ngClass]="{ 'is-invalid': submitted && f['outlet_id'].errors }">
                        </ng-select>
                        <div class="invalid-feedback" *ngIf="submitted && f['outlet_id'].errors">
                            <div *ngIf="f['outlet_id'].errors['required']">Outlet is required</div>
                        </div> -->
                    </div>
                    <div *ngIf="isSalesRole" class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                        <label>Product Category</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                        <!-- <select formControlName="product_category" class="form-select"
                            [ngClass]="{ 'is-invalid': submitted && f['product_category'].errors }">
                            <option value="" disabled selected>--Select Product Category--</option>
                            <option *ngFor="let prodCat of filterProdCat" [value]="prodCat.category_id">
                                {{ prodCat.product_category }}
                            </option>
                        </select> -->
                        <ng-multiselect-dropdown [placeholder]="'Select Product Category'"
                            formControlName="product_category" class="form-control"
                            [settings]="dropdownSettingsProCategory" [data]="filterProdCat"
                            [ngClass]="{ 'is-invalid': submitted && f['product_category'].errors }">
                        </ng-multiselect-dropdown>
                        <div class="invalid-feedback" *ngIf="submitted && f['product_category'].errors">
                            <div *ngIf="f['product_category'].errors['required']">Product Category is required</div>
                        </div>
                    </div>
                    <div *ngIf="ismspinRole" class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                        <label>SMPIN</label>
                        <span style="color: red; font-size: 15px;">&nbsp;*</span>
                        <select formControlName="mspin" class="form-select"
                            [ngClass]="{ 'is-invalid': submitted && f['mspin'].errors }">
                            <option value="" disabled selected>--Select SMPIN--</option>
                            <option *ngFor="let mspinData of filteredProducts" [value]="mspinData.mspin">
                                {{ mspinData.mspin }}
                            </option>
                        </select>
                        <div class="invalid-feedback" *ngIf="submitted && f['mspin'].errors">
                            <div *ngIf="f['mspin'].errors['required']">SMPIN is required</div>
                        </div>
                    </div>


                    <!-- Area Dropdown -->
                    <div *ngIf="isAreaRole" class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                        <label>Area</label>
                        <span style="color: red; font-size: 15px;">&nbsp;*</span>
                        <ng-multiselect-dropdown [placeholder]="'Select Area'" formControlName="area_id"
                            class="form-control" [settings]="dropdownSettingsArea" [data]="areaValue"
                            [ngClass]="{ 'is-invalid': submitted && f['area_id'].errors }">
                        </ng-multiselect-dropdown>
                        <!-- <ng-select 
                                formControlName="area_id"
                                [items]="areaValue"
                                bindLabel="area_name"
                                bindValue="id"
                                [multiple]="true"
                                [closeOnSelect]="false"
                                [placeholder]="' '"
                                [ngClass]="{ 'is-invalid': submitted && f['area_id'].errors }">
                            </ng-select> -->
                        <div class="invalid-feedback" *ngIf="submitted && f['area_id'].errors">
                            <div *ngIf="f['area_id'].errors['required']">Area is required</div>
                        </div>
                    </div>

                    <!-- Zone Dropdown -->
                    <div *ngIf="isZoneRole" class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                        <!-- <label>Zone</label>
                        <span style="color: red; font-size: 15px;">&nbsp;*</span>
                        <select formControlName="zone_id" class="form-select"
                            [attr.value]="userForm.get('zone_id')?.value"
                            [ngClass]="{ 'is-invalid': submitted && f['zone_id'].errors }">
                            <option value="" disabled selected>--Select
                                Zone--</option>
                            <option *ngFor="let zone of zoneValue" [value]="zone.id">{{ zone.zone_name }}</option>
                        </select>
                        <div class="invalid-feedback" *ngIf="submitted && f['zone_id'].errors">
                            <div *ngIf="f['zone_id'].errors['required']">Zone
                                is required</div>
                        </div> -->
                        <label>Zone</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                        <ng-select formControlName="zone_id" [items]="zoneValue" bindLabel="zone_name" bindValue="id"
                            [placeholder]="' '" [ngClass]="{ 'is-invalid': submitted && f['zone_id'].errors }">
                        </ng-select>
                        <div class="invalid-feedback" *ngIf="submitted && f['zone_id'].errors">
                            <div *ngIf="f['zone_id'].errors['required']">Zone is required</div>
                        </div>
                    </div>

                    <!-- Region Dropdown -->
                    <div *ngIf="isRegionRole" class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                        <!-- <label>Region</label>
                        <span style="color: red; font-size: 15px;">&nbsp;*</span>
                        <select formControlName="region_id" class="form-select"
                            [attr.value]="userForm.get('region_id')?.value"
                            [ngClass]="{ 'is-invalid': submitted && f['region_id'].errors }">
                            <option value="" disabled selected>--Select
                                Region--</option>
                            <option *ngFor="let region of regionValue" [value]="region.id">{{ region.region_name }}
                            </option>
                        </select>
                        <div class="invalid-feedback" *ngIf="submitted && f['region_id'].errors">
                            <div *ngIf="f['region_id'].errors['required']">Region
                                is required</div>
                        </div> -->
                        <label>Region</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                        <ng-multiselect-dropdown [placeholder]="'Select Region'" formControlName="region_id"
                            class="form-control" [settings]="dropdownSettingsRegion" [data]="regionValue"
                            [ngClass]="{ 'is-invalid': submitted && f['region_id'].errors }">
                        </ng-multiselect-dropdown>
                        <!-- <ng-select 
                            formControlName="region_id"
                            [items]="regionValue"
                            bindLabel="region_name"
                            bindValue="id"
                            [multiple]="true"
                            [closeOnSelect]="false"
                            [placeholder]="' '"
                            [ngClass]="{ 'is-invalid': submitted && f['region_id'].errors }">
                        </ng-select> -->
                        <div class="invalid-feedback" *ngIf="submitted && f['region_id'].errors">
                            <div *ngIf="f['region_id'].errors['required']">Region is required</div>
                        </div>
                    </div>
                    <!-- Parent Dealer -->
                    <ng-container *ngIf="selectedRoleId == 9">
                        <div *ngIf="isParentRole" class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                            <!-- <label>Parent Dealer</label>
                        <span style="color: red; font-size: 15px;">&nbsp;*</span>
                        <select formControlName="parent_dealer_id" class="form-select"
                            [attr.value]="userForm.get('parent_dealer_id')?.value"
                            [ngClass]="{ 'is-invalid': submitted && f['parent_dealer_id'].errors }">
                            <option value="" disabled selected>--Select
                                Parent Dealer--</option>
                            <option *ngFor="let parent_dealer of parent_dealerValue" [value]="parent_dealer.id">{{
                                parent_dealer.dealer_name }}</option>
                        </select>
                        <div class="invalid-feedback" *ngIf="submitted && f['parent_dealer_id'].errors">
                            <div *ngIf="f['parent_dealer_id'].errors['required']">Parent Dealer
                                is required</div>
                        </div> -->
                            <label>Parent Dealer</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
                            <ng-select formControlName="parent_dealer_id" [items]="parent_dealerValue"
                                bindLabel="dealer_name" bindValue="id" [placeholder]="' '"
                                [ngClass]="{ 'is-invalid': submitted && f['parent_dealer_id'].errors }">
                            </ng-select>
                            <div class="invalid-feedback" *ngIf="submitted && f['parent_dealer_id'].errors">
                                <div *ngIf="f['parent_dealer_id'].errors['required']">Parent Dealer is required</div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="selectedRoleId == 10">
                        <div *ngIf="isParentRole" class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
                            <label>Dealer Principal</label>
                            <span style="color: red; font-size: 15px;">&nbsp;*</span>
                            <select formControlName="parent_dealer_id" class="form-select outlet-select"
                                [attr.value]="userForm.get('parent_dealer_id')?.value"
                                [ngClass]="{ 'is-invalid': submitted && f['parent_dealer_id'].errors }">
                                <option value="" disabled selected>--Select
                                    Dealer Principal--</option>
                                <option [disabled]="parent_dealer.disabled"
                                    *ngFor="let parent_dealer of parent_dealerValue" [value]="parent_dealer.id">{{
                                    parent_dealer.dealer_name }} ({{
                                    parent_dealer.dealer_code }}-{{ parent_dealer?.location_code }})</option>
                            </select>
                            <div class="invalid-feedback" *ngIf="submitted && f['parent_dealer_id'].errors">
                                <div *ngIf="f['parent_dealer_id'].errors['required']">Parent Dealer
                                    is required</div>
                            </div>

                            <div class="invalid-feedback" *ngIf="submitted && f['parent_dealer_id'].errors">
                                <div *ngIf="f['parent_dealer_id'].errors['required']">Parent Dealer is required</div>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div class="col-lg-12 mt-5 two-btn">
                    <div class="text-right-right">
                        <button mat-raised-button class="create-button" (click)="clearForm()">Clear</button>
                        <button class="create-button ml-2" mat-raised-button (click)="createUser()">Create</button>

                    </div>
                </div>

            </form>
        </ng-container>

        <ng-container *ngIf="isUserVerification">
            <div class="header-container">
                <h2>User Verified By</h2>
                <div class="button-container">
                    <button mat-raised-button class="add-button" (click)="back()">
                        Back to List
                    </button>
                </div>
            </div>

            <div class="leads-table mb-3">
                <table mat-table [dataSource]="verificationDataSource" matSort class="mat-table">

                    <!-- S.No -->
                    <ng-container matColumnDef="SNo">
                        <th mat-header-cell *matHeaderCellDef>S.No</th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            {{ (verificationPaginator.pageIndex * verificationPaginator.pageSize) + (i + 1) }}
                        </td>
                    </ng-container>


                    <!-- Outlet Name -->
                    <ng-container matColumnDef="username">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Username
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.username }}
                        </td>
                    </ng-container>

                    <!-- Outlet Code -->
                    <ng-container matColumnDef="createdAt">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Verified Date
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.createdAt }}
                        </td>
                    </ng-container>

                    <!-- IP Adress -->
                    <ng-container matColumnDef="ip_address">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            IP Address
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.ip_address }}
                        </td>
                    </ng-container>

                    <!-- Outlet Map Code -->
                    <!--<ng-container matColumnDef="outlet_map_code">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Outlet Map Code
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.outlet_map_code }}
            </td>
          </ng-container> -->

                    <tr mat-header-row *matHeaderRowDef="verificationDisplayedColumns; sticky: true">
                    </tr>

                    <tr mat-row *matRowDef="let row; columns: verificationDisplayedColumns;">
                    </tr>

                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell text-center p-3" colspan="5">
                            No data found!
                        </td>
                    </tr>
                </table>

                <mat-paginator #verificationPaginator [pageSizeOptions]="[10, 20]" showFirstLastButtons>
                </mat-paginator>
            </div>
        </ng-container>
    </div>
</div>


<ng-template #setPasswordTemp>
    <h4 mat-dialog-title>
        Reset Password
    </h4>
    <div class="container-fluid pl-0">
        <div class="container-upload">
            <!-- <div class="title">
                <p class="text-left head-text">Reset Password</p>
                <p class="text-left sub-head">Please enter your current password and new password to reset your password
                </p>
            </div> -->
            <div class="row justify-content-center">
                <div class="col-7 upload-container">
                    <form [formGroup]="passwordForm">
                        <div class="form-group mt-4">
                            <label for="newPassword">Enter New Password</label>
                            <div class="input-group">
                                <input [type]="inputNewPass" class="form-control" id="newPassword" autocomplete="off"
                                    formControlName="newPassword" placeholder="Password"
                                    [attr.value]="passwordForm.get('newPassword')?.value"
                                    [ngClass]="{ 'is-invalid': submitted && f['newPassword'].errors }"
                                    onpaste="return false;" oncopy="return false;" oncut="return false;">
                                <div class="input-group-append">
                                    <span class="input-group-text"><i class="bi bi-eye-slash"
                                            (click)="passwordNew('hide')" *ngIf="isHideNew"></i>
                                        <i class="bi bi-eye" (click)="passwordNew('show')" *ngIf="isShowNew"></i></span>
                                </div>
                                <div *ngIf="submitted && f['newPassword'].errors" class="invalid-feedback">
                                    <div *ngIf="f['newPassword'].errors['required']">
                                        New Password is required
                                    </div>
                                    <div *ngIf="f['newPassword'].errors['pattern']">
                                        Password must be at least 8 characters long, include a number, a special
                                        character,
                                        and a capital letter.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group mt-4">
                            <label for="confirmPassword">Confirm New Password</label>
                            <div class="input-group">
                                <input [type]="inputConfirmPass" class="form-control" id="confirmPassword"
                                    formControlName="confirmPassword"
                                    [attr.value]="passwordForm.get('confirmPassword')?.value"
                                    [ngClass]="{ 'is-invalid': submitted && f['confirmPassword'].errors }"
                                    autocomplete="off" placeholder="Password" onpaste="return false;"
                                    oncopy="return false;" oncut="return false;">
                                <div class="input-group-append">
                                    <span class="input-group-text"><i class="bi bi-eye-slash"
                                            (click)="passwordConfirm('hide')" *ngIf="isHideConfirm"></i>
                                        <i class="bi bi-eye" (click)="passwordConfirm('show')"
                                            *ngIf="isShowConfirm"></i></span>
                                </div>
                                <div *ngIf="submitted && f['confirmPassword'].errors" class="invalid-feedback">
                                    <div *ngIf="f['confirmPassword'].errors['required']">
                                        Confirm Password is required
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="button-row">
                            <button #cancelButton class="btn white-btn" type="button" (click)="closePassowrd()">
                                Cancel
                            </button>
                            <button type="submit" style="font-size: 14px !important;" class="btn btn-primary"
                                (click)="setPassword()">
                                Reset Password
                            </button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</ng-template>